import { useMemo } from 'react';
import {
  Delete as DeleteIcon,
  Pause as PauseIcon,
  PlayArrow as PlayIcon,
} from '@mui/icons-material';
import { format } from 'date-fns';
import DialogBox from '@/components/DialogBox';
import TransparentButton from '@/trio-ui/TransparentButton';
import * as Styles from './AudioPlayer.styles';

type AudioPlayerComponentProps = {
  remainingTime: number;
  isPlaying: boolean;
  canDelete: boolean;
  isDeleteModalOpen: boolean;
  audioPlayerId: string;
  onPlay: () => void;
  onPause: () => void;
  onToggleDeleteModal: (event?: any) => void;
  onDelete: () => void;
};

const UNIT_IN_MILLISECONDS = 1000;

export default function AudioPlayerComponent({
  remainingTime,
  isPlaying,
  canDelete,
  audioPlayerId,
  isDeleteModalOpen,
  onPlay,
  onPause,
  onDelete,
  onToggleDeleteModal,
}: AudioPlayerComponentProps): JSX.Element {
  const formattedRemainingTime = format(remainingTime * UNIT_IN_MILLISECONDS, 'mm:ss');

  const audioPlayerProperties = useMemo(
    () => ({
      action: isPlaying ? onPause : onPlay,
      icon: isPlaying ? <PauseIcon /> : <PlayIcon />,
    }),
    [isPlaying, onPause, onPlay]
  );

  return (
    <>
      <Styles.Container>
        <Styles.Box onClick={audioPlayerProperties.action}>
          <Styles.Button>{audioPlayerProperties.icon}</Styles.Button>

          <audio id={audioPlayerId} />

          <Styles.Timer>{formattedRemainingTime}</Styles.Timer>
        </Styles.Box>

        {!!canDelete && (
          <Styles.DeleteButton>
            <TransparentButton
              icon={DeleteIcon}
              isRedButton
              onClick={(event) => onToggleDeleteModal(event)}
            >
              Delete
            </TransparentButton>
          </Styles.DeleteButton>
        )}
      </Styles.Container>

      <DialogBox
        isOpen={isDeleteModalOpen}
        onCancelHandler={onToggleDeleteModal}
        onConfirmHandler={onDelete}
      />
    </>
  );
}
